module.exports = __webpack_public_path__ + "img/turkey-solution.d2a64cb4.png";